'use client';

import { useEffect, useState } from 'react';

import { Accordion } from '@gds/Accordion/Accordion';
import type { AccordionProps } from '@gds/Accordion/Accordion.types';

export const AnchoredAccordion = (props: Omit<AccordionProps, 'open'> & { id: string }) => {
  const { id } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (window.location.hash !== `#${id}`) return;

    setOpen(true);
    document.getElementById(id)?.scrollIntoView();
  }, [id]);

  return <Accordion {...props} open={open} />;
};
